import { render, staticRenderFns } from "./RolePermissionModal.vue?vue&type=template&id=9c7b6e6a&scoped=true&"
import script from "./RolePermissionModal.vue?vue&type=script&lang=js&"
export * from "./RolePermissionModal.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissionModal.vue?vue&type=style&index=0&id=9c7b6e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7b6e6a",
  null
  
)

export default component.exports